$(document).ready(function () {

    // Animate function
    function animateCSS(el, animation, prefix = 'animate__') {
        var animationName = `${prefix}${animation}`;

        $(el).addClass(`${prefix}animated`);
        $(el).addClass(animationName);

        // When the animation ends, we clean the classes and resolve the Promise
        function handleAnimationEnd(event) {
            event.stopPropagation();
            $(el).removeClass(`${prefix}animated`);
            $(el).removeClass(animationName);
        }

        $(el).on('animationend', handleAnimationEnd, { once: true });
    }

    // Determine if an element is in the visible viewport
    function isInViewport(element) {
        var rect = element.getBoundingClientRect();
        var html = document.documentElement;
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || html.clientHeight) &&
            rect.right <= (window.innerWidth || html.clientWidth)
        );
    }

    function handleAppearAnimation(el, animation) {
        if (isInViewport(el)) {
            if (!$(el).hasClass('animated')) {
                $(el).addClass('animated');
                animateCSS(el, animation);
            }
        } else {
            // Check again in a bit
            setTimeout(function () {
                handleAppearAnimation(el, animation);
            }, 100);
        }
    }

    $('[data-animate-on-appear]').each(function () {
        // Add a scroll listener to watch for when this appears
        var el = this;
        var animation = $(this).data('animate-on-appear');

        handleAppearAnimation(el, animation);


        //document.addEventListener("scroll", (event) => {
        //    if (isInViewport(el)) {
        //        if (!$(el).hasClass('animated')) {
        //            $(el).addClass('animated');
        //            animateCSS(el, animation);
        //        }                
        //    }
        //});
    });

    function animateParallaxExpand($el) {
        var clientWidth = document.documentElement.clientWidth;
        var clientHeight = document.documentElement.clientHeight;
        var distanceTravel = parseInt(clientWidth * .15);
        var startPosition = distanceTravel;
        var endPosition = startPosition + distanceTravel;
        var scrollTop = $(document).scrollTop();
        var offsetBuffer = 0;// 100;
        var scrollBottom = scrollTop + clientHeight;
        var elTop = $el.offset().top;
        var positionOffset = elTop - scrollTop - offsetBuffer + $el.height();
        // get safe values
        positionOffset = Math.max(0, positionOffset);
        positionOffset = Math.min(clientHeight, positionOffset);

        // flip the offset
        positionOffset = clientHeight - positionOffset;
        var offsetPercent = positionOffset / clientHeight;
        var actualOffset = parseInt(offsetPercent * distanceTravel);


        var position = startPosition - actualOffset;

        $el.css('margin-left', position + 'px');
        var $pair = $el.find('.parallax-expand-pair');
        if ($pair.data('original-left') === undefined) {
            $pair.data('original-left', $pair.css('left'));
        }
        $pair.css('left', 'calc(' + $pair.data('original-left') + ' - ' + (position * 2) + 'px)');

        //console.log('scrollTop: ' + scrollTop
        //    + ', elTop: ' + elTop
        //    + ', scrollBottom: ' + scrollBottom
        //    + ', distanceTravel: ' + distanceTravel
        //    + ', actualOffset: ' + actualOffset
        //    + ', calc: ' + 'calc(' + $pair.data('original-left') + ' - ' + (position*2) + 'px)'
        //    + ', position: ' + position);
    }

    $('.parallax-expand').each(function () {
        var $el = $(this);
        animateParallaxExpand($el);

        $(document).on('scroll', function () {
            animateParallaxExpand($el);
        });
    });
});
